import { Address } from 'models/Address/address.model';
import { serializable, alias, primitive, list, object } from 'serializr';
export class Origins {
    @serializable
    id?: number;

    @serializable
    share?: number | null = null;

    @serializable
    addressLabel?: string | null = null;

    @serializable(alias('best_fit_region', primitive()))
    bestFitRegion?: string | null = null;

    @serializable(alias('activity_mapping_region_spec_id', primitive()))
    activityMappingRegionSpecId?: string | null = null;

    @serializable(alias('address', object(Address)))
    address?: Address | null = new Address();

    @serializable
    unit?: string | null;
}

export class ScopeThreeSection {
    @serializable
    id?: number;

    @serializable(alias('activity_label', primitive()))
    activityLabel?: string | null = null;

    @serializable
    quantity?: number | null = null;

    @serializable
    unit?: string | null = null;

    @serializable(list(object(Origins)))
    origins: Origins[] = [new Origins()];

    @serializable(alias('best_fit_region', primitive()))
    bestFitRegion?: string | null;

    @serializable(alias('activity_mapping_region_spec_id', primitive()))
    activityMappingRegionSpecId?: string | null = null;

    @serializable(object(Address))
    address?: Address | null;

    ingredients?: string;

    packagings?: string;

    others?: string;

    fertilizers?: string;

    addressLabel?: string | null = null;

    @serializable(alias('multi_origin', primitive()))
    multiOrigin?: boolean = false;
}

export class ScopeThreeCategoryOne {

    @serializable(list(object(ScopeThreeSection)))
    ingredients?: ScopeThreeSection[] = [new ScopeThreeSection()];

    @serializable(list(object(ScopeThreeSection)))
    packagings?: ScopeThreeSection[] = [new ScopeThreeSection()];

    @serializable(list(object(ScopeThreeSection)))
    others?: ScopeThreeSection[] = [new ScopeThreeSection()];

    @serializable(list(object(ScopeThreeSection)))
    fertilizers?: ScopeThreeSection[] = [];

}

